"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleCalendarFilter = exports.clearFilteredResources = exports.setFilteredResources = exports.dispatchAppointmentEditor = exports.closeAppointmentDialog = exports.openAppointmentDialog = void 0;
function openAppointmentDialog(appointmentId, personId, userName, start, end, notes) {
    return {
        type: "OpenAppointmentDialog",
        payload: {
            appointmentId: appointmentId,
            personId: personId,
            userName: userName,
            start: start,
            end: end,
            notes: notes,
        },
    };
}
exports.openAppointmentDialog = openAppointmentDialog;
function closeAppointmentDialog() {
    return {
        type: "CloseAppointmentDialog",
    };
}
exports.closeAppointmentDialog = closeAppointmentDialog;
function dispatchAppointmentEditor(action) {
    return {
        type: "DispatchAppointmentEditor",
        action: action,
    };
}
exports.dispatchAppointmentEditor = dispatchAppointmentEditor;
function setFilteredResources(resources) {
    return {
        type: "SetFilteredResources",
        resources: resources,
    };
}
exports.setFilteredResources = setFilteredResources;
function clearFilteredResources() {
    return {
        type: "ClearFilteredResources",
    };
}
exports.clearFilteredResources = clearFilteredResources;
function toggleCalendarFilter() {
    return {
        type: "ToggleCalendarFilter",
    };
}
exports.toggleCalendarFilter = toggleCalendarFilter;
//# sourceMappingURL=calendar-actions.js.map